import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-user-table-toolbar": "base"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Add User ")
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = {
  href: "#",
  class: "text-gray-600 text-hover-primary mb-1"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "EDIT", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "DELETE", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AddUserModal = _resolveComponent("AddUserModal")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_add_user",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSelectedItem(null)))
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
              ]),
              _hoisted_7
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.myUsers,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true
        }, {
          "cell-name": _withCtx(({ row: user }) => [
            _createTextVNode(_toDisplayString(user.name), 1)
          ]),
          "cell-email": _withCtx(({ row: user }) => [
            _createElementVNode("a", _hoisted_9, _toDisplayString(user.email), 1)
          ]),
          "cell-role": _withCtx(({ row: user }) => [
            _createTextVNode(_toDisplayString(user.role), 1)
          ]),
          "cell-actions": _withCtx(({ row: user }) => [
            _createElementVNode("button", {
              type: "button",
              class: "el-button el-button--success is-round el-button--mini",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_add_user",
              onClick: ($event: any) => (_ctx.setSelectedItem(user))
            }, _hoisted_12, 8, _hoisted_10),
            _createElementVNode("button", {
              type: "button",
              class: "el-button el-button--danger is-round el-button--mini",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_delete",
              onClick: ($event: any) => (_ctx.setSelectedItem(user))
            }, _hoisted_15, 8, _hoisted_13)
          ]),
          _: 1
        }, 8, ["table-data", "table-header"])
      ])
    ]),
    _createVNode(_component_AddUserModal, { user: _ctx.selectedItem }, null, 8, ["user"]),
    _createVNode(_component_DeleteModal, {
      item: _ctx.selectedItem,
      model: "User",
      endpoint: "users"
    }, null, 8, ["item"])
  ], 64))
}